import axios from 'axios'

export default {
  namespaced: true,
  state: {
    sites: sessionStorage.getItem('sitesstore_sites') ? JSON.parse(sessionStorage.getItem('sitesstore_sites')) : false
  },
  mutations: {
    fetch (state, sites) {
      state.sites = sites
      sessionStorage.setItem('sitesstore_sites', JSON.stringify(sites))
    }
  },
  actions: {
    // 更新口令牌
    fetch ({commit, state}) {
      if (state.sites) {
        return false
      }
      axios('/common/site/').then((response) => {
        commit('fetch', response.data)
      }).catch((error) => {
        console.error(error) // eslint-disable-line no-console
      })
    }
  },
  getters: {
    sites: (state) => {
      return state.sites || []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/SitesStore.js